import React from 'react';
import { Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Rating from "./Rating";
import WishlistHeart from "./WishlistHeart";

const Product = ({ product, showDiscount }) => {
    // Ensure product.price is a number
    const price = Number(product.price); // Convert to number

    // Default discount to 0 if not provided
    const discount = product.discount ?? 0;

    // Calculate the discounted price
    const discountedPrice = (price - (price * (discount / 100))).toFixed(2);
    const discountPercentage = (discount).toFixed(0); // Format discount percentage to 0 decimal places

    // Log the discount percentage and product details to console for debugging
    // console.log('Product:', product);
    // console.log('Discount Percentage:', discountPercentage);
    // console.log('Price Type:', typeof price);

    // Check if price is a valid number
    if (isNaN(price)) {
        return (
            <div>
                <h4>Error: Invalid price</h4>
                <p>Product: {JSON.stringify(product)}</p>
                <p>Discount Percentage: {discountPercentage}</p>
                <p>Price Type: {typeof price}</p>
            </div>
        ); // Show error details
    }

    // Generate descriptive alt text for product image
    const generateAltText = () => {
        const baseText = product.name;
        const priceText = showDiscount && product.isClearance && discount > 0
            ? `On sale for £${discountedPrice}, was £${price.toFixed(2)}`
            : `Priced at £${price.toFixed(2)}`;
        const ratingText = product.numReviews > 0
            ? `, ${product.rating} star rating with ${product.numReviews} reviews`
            : '';

        return `${baseText} - ${priceText}${ratingText}`;
    };

    return (
        <Card className='my-3 p-3 rounded'>
            <WishlistHeart productId={product._id} productName={product.name} />
            <Link to={`/product/${product.slug || product._id}`}>
                <Card.Img
                    src={product.image}
                    variant='top'
                    alt={generateAltText()}
                    className="product-img"
                    loading="lazy"
                />
            </Link>

            <Card.Body>
                <Link to={`/product/${product.slug || product._id}`} style={{ textDecoration: 'none' }}>
                    <Card.Title as="div" className="product-title">
                        <strong>{product.name}</strong>
                    </Card.Title>
                </Link>

                {showDiscount && product.isClearance && discount > 0 ? (
                    <>
                        <Card.Text as='div' className="product-price original-price" style={{ textDecoration: 'line-through' }}>
                            £{price.toFixed(2)}
                        </Card.Text>
                        <Card.Text as='div' className="product-price discounted-price">
                            Now: £{discountedPrice}
                        </Card.Text>
                        <Card.Text as='div' className="product-price product-promo">
                            Save {discountPercentage}%
                        </Card.Text>
                    </>
                ) : (
                    <Card.Text as='div' className="product-price">
                        £{price.toFixed(2)}
                    </Card.Text>
                )}

                <Card.Text as="div" className="product-rating">
                    <Rating value={product.rating || 0} text={`${product.numReviews || 0} review${product.numReviews === 1 ? '' : 's'}`} />
                </Card.Text>
            </Card.Body>
        </Card>
    );
};

export default Product;
